
export enum ElementErrorCode {
    ELEMENT_TYPE_DOES_NOT_CONFORM_TO_STEREOTYPE = "ELEMENT_TYPE_DOES_NOT_CONFORM_TO_STEREOTYPE",
    STEREOTYPE_ALREADY_ASSIGNED = "STEREOTYPE_ALREADY_ASSIGNED",
    UNKNOWN_STEREOTYPE = "UNKNOWN_STEREOTYPE",
}